import { render, staticRenderFns } from "./Document-history-table.vue?vue&type=template&id=2aa138fc"
import script from "./Document-history-table.vue?vue&type=script&lang=js"
export * from "./Document-history-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports